<template>
	<div class="siteService-item-wrapper">
		<div class="titleArea">
			<div class="verticalIndicator"></div>
			<div class="title">
				{{ title }}
			</div>
		</div>
		<div class="servicesItems">
			<template v-if="!richText">
				<div class="serviceItem" v-for="(item,index) in items" :key="index">
					{{ item }}
				</div>
			</template>
			<div class="richText" v-if="richText">
				<div v-html="nodesArray"></div>
			</div>
		</div>
	</div>
</template>

<script>
	// import {parseHtml} from '../../../utils/parse.js'
export default {
  props: {
    title: String,
    items: Array,
    richText: Boolean
  },
	
  data () {
    return {}
  },
	
  created () {
  },

  computed: {
    nodesArray () {
      if (this.items.length > 0) {
        var rawhtml = this.items[0]
        // rawhtml = rawhtml.replace(/<img/gi, '<img style="max-width:100%;height:auto;"')
        // let results = parseHtml(rawhtml)
        return rawhtml
      } else {
        return ''
      }
    }
  },
	
  methods: {
    itemStyle () {
      return {
        'width': 'calc(100% / 3)'
      }
    }
  }
}
</script>

<style lang="scss">
@import '../style/var.scss';
	.siteService-item-wrapper {
		background: white;
		height: 100%;
		.titleArea {
			height: 2.1333rem;
			margin-left: 0.64rem;
			margin-right: 0.64rem;
			display: flex;
			flex: 1 1 0%;
			align-items: center;
			border-bottom:0.0213rem solid #d8d8d8;
			.verticalIndicator {
				width: 0.0853rem;
				height: 0.4267rem;
				background: $button-background-color;
			}
			.title {
				font-size: 0.64rem;
				margin-left: 0.4267rem;
			}
		}
		.servicesItems {
			display: flex;
			justify-items: center;
			width: 100%;
			margin-bottom: 0.8533rem;
			flex-wrap: wrap;
			.serviceItem {
				width: calc(100% / 3);
				font-size: 0.512rem;
				color: $button-text-color;
				text-align: center;
				margin-top: 0.8533rem;
			}
			.richText {
				margin: 0.64rem;
				font-size: 0.64rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// siteServicesItem.vue?304e46d1